/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export const toastCss = `
          .toast-container {
            display: flex;
            flex-direction: column;
            position: fixed;
            bottom: 0;
            z-index: 1000;
            margin: 80px; 
            right:0;
            }
          .toaster {
            position: relative;
            bottom: 20px;
            display: inline-flex;
            justify-content: space-between;
             padding: 0.5rem;
            margin: 8px;
            box-shadow: 0px 2px 2px rgba(0, 43, 85, 0.08),
            0px 4px 4px rgba(0, 43, 85, 0.08), 0px 8px 8px rgba(0, 43, 85, 0.08),
            0px 16px 16px rgba(0, 43, 85, 0.08), 0px 32px 32px rgba(0, 43, 85, 0.08);
            border-radius: 4px;
            color: #ffffff;
            line-height: 32px;
            min-height: 52px;
            animation: fadeIn ease 2s;

            @keyframes fadeIn {
            0% {
             opacity: 0;
                }
            100% {
            opacity: 1;
                 }
                                 }

            @keyframes fadeOut {
            0% {
             opacity: 1;
                 }
            100% {
            opacity: 0;
                 }
                               }

            .icon {
             margin-right: 0.5rem;
             position: relative;
             top: -2px;
                    }

            .message {
            border-right: 1px solid #ffffff;
            padding-right: 1rem;
                       }

            .toast-content {
            display: inline-flex;
            align-items: center;
                            }

            .action {
             margin-right: 0.5rem;
                    }

            .dismiss {
            display: flex;
            align-items: center;
            cursor: pointer;
            cursor: pointer;
            padding-left: 1rem;
            padding-right: 0.1rem;
            position: relative;
            top: -2px;
                    }
            clr-icon {
            display: flex;
            width: 24px;
            height: 24px;
                      }
            .icon clr-icon {
            width: 32px;
            height: 32px;
                             }

            &.error {
              background-color: #bb2a33;
                    }

            &.warning {
            background-color: #f2af00;
            color: #000;

             .message {
              border-right: 1px solid #000;
                      }
                    }

            &.info {
             background-color: #41b6e6;
             color: #000;

             .message {
              border-right: 1px solid #000;
                      }
                    }

             &.success {
            background-color: #6ea204;
                        }

             &.hide {
            animation: fadeOut ease 0.5s;
                     }
                }`;
